// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: BpHwiUHInqZk
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  initializeCodeComponentStates,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import { AntdSelect } from "@plasmicpkgs/antd5/skinny/registerSelect";
import { Select } from "@plasmicpkgs/antd/skinny/registerSelect";
import { Option } from "@plasmicpkgs/antd/skinny/registerOption";
import PermissionChip from "../../PermissionChip"; // plasmic-import: SruSaz4XhKEy/component
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicEditRoleModal.module.css"; // plasmic-import: BpHwiUHInqZk/css

createPlasmicElementProxy;

export const PlasmicEditRoleModal__VariantProps = new Array();

export const PlasmicEditRoleModal__ArgProps = new Array();

const $$ = {};

function PlasmicEditRoleModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "roleName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "permissionSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "permissionSelectionStack.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "permissionSelectionStack.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__hv8Sb)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__t8KcN
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h6
                className={classNames(
                  projectcss.all,
                  projectcss.h6,
                  projectcss.__wab_text,
                  sty.h6__dksyJ
                )}
              >
                {"Edit Role Name"}
              </h6>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__cDnyN)}>
        {(() => {
          const child$Props = {
            className: classNames("__wab_instance", sty.roleName),
            onChange: async (...eventArgs) => {
              generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["roleName", "value"],
                AntdInput_Helpers
              ).apply(null, eventArgs);
            },
            placeholder: "Enter Here",
            value: generateStateValueProp($state, ["roleName", "value"])
          };
          initializeCodeComponentStates(
            $state,
            [
              {
                name: "value",
                plasmicStateName: "roleName.value"
              }
            ],

            [],
            AntdInput_Helpers ?? {},
            child$Props
          );
          return (
            <AntdInput
              data-plasmic-name={"roleName"}
              data-plasmic-override={overrides.roleName}
              {...child$Props}
            />
          );
        })()}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__t6JS)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__fjuJo
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h6
                className={classNames(
                  projectcss.all,
                  projectcss.h6,
                  projectcss.__wab_text,
                  sty.h6___2OHnl
                )}
              >
                {"Add permissions"}
              </h6>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"permissionSelectStack"}
        data-plasmic-override={overrides.permissionSelectStack}
        className={classNames(projectcss.all, sty.permissionSelectStack)}
      >
        <AntdSelect
          data-plasmic-name={"permissionSelect"}
          data-plasmic-override={overrides.permissionSelect}
          autoFocus={false}
          className={classNames("__wab_instance", sty.permissionSelect)}
          defaultOpen={false}
          defaultStylesClassName={classNames(
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens
          )}
          dropdownMatchSelectWidth={true}
          mode={"single"}
          onChange={async (...eventArgs) => {
            generateStateOnChangeProp($state, [
              "permissionSelect",
              "value"
            ]).apply(null, eventArgs);
          }}
          options={[
            { value: "option1", label: "Option 1", type: "option" },
            { value: "option2", label: "Option 2", type: "option" }
          ]}
          placeholder={"Select..."}
          popupScopeClassName={sty["permissionSelect__popup"]}
          value={generateStateValueProp($state, ["permissionSelect", "value"])}
        />

        <Select
          data-plasmic-name={"permissionSelectionStack"}
          data-plasmic-override={overrides.permissionSelectionStack}
          allowClear={true}
          bordered={false}
          className={classNames("__wab_instance", sty.permissionSelectionStack)}
          listHeight={256}
          mode={"multiple"}
          onChange={async (...eventArgs) => {
            generateStateOnChangeProp($state, [
              "permissionSelectionStack",
              "value"
            ]).apply(null, eventArgs);
          }}
          onDropdownVisibleChange={async (...eventArgs) => {
            generateStateOnChangeProp($state, [
              "permissionSelectionStack",
              "open"
            ]).apply(null, eventArgs);
          }}
          open={generateStateValueProp($state, [
            "permissionSelectionStack",
            "open"
          ])}
          placeholder={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__p3QEl
              )}
            >
              {"Select"}
            </div>
          }
          showArrow={true}
          showSearch={true}
          size={"large"}
          value={generateStateValueProp($state, [
            "permissionSelectionStack",
            "value"
          ])}
          virtual={true}
        >
          <Option
            data-plasmic-name={"antdOption"}
            data-plasmic-override={overrides.antdOption}
            className={classNames("__wab_instance", sty.antdOption)}
            value={"Option"}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__qXdst
              )}
            >
              {"Option"}
            </div>
          </Option>
        </Select>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__kmNpb)}>
        <div
          data-plasmic-name={"permissionChipsStack"}
          data-plasmic-override={overrides.permissionChipsStack}
          className={classNames(projectcss.all, sty.permissionChipsStack)}
        >
          <PermissionChip
            data-plasmic-name={"permissionChip"}
            data-plasmic-override={overrides.permissionChip}
            className={classNames("__wab_instance", sty.permissionChip)}
          />
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__liMj)}>
        <Button
          data-plasmic-name={"saveEditRoleBtn"}
          data-plasmic-override={overrides.saveEditRoleBtn}
          className={classNames("__wab_instance", sty.saveEditRoleBtn)}
        >
          {"Save"}
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "roleName",
    "permissionSelectStack",
    "permissionSelect",
    "permissionSelectionStack",
    "antdOption",
    "permissionChipsStack",
    "permissionChip",
    "saveEditRoleBtn"
  ],

  roleName: ["roleName"],
  permissionSelectStack: [
    "permissionSelectStack",
    "permissionSelect",
    "permissionSelectionStack",
    "antdOption"
  ],

  permissionSelect: ["permissionSelect"],
  permissionSelectionStack: ["permissionSelectionStack", "antdOption"],
  antdOption: ["antdOption"],
  permissionChipsStack: ["permissionChipsStack", "permissionChip"],
  permissionChip: ["permissionChip"],
  saveEditRoleBtn: ["saveEditRoleBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEditRoleModal__ArgProps,
          internalVariantPropNames: PlasmicEditRoleModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEditRoleModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEditRoleModal";
  } else {
    func.displayName = `PlasmicEditRoleModal.${nodeName}`;
  }
  return func;
}

export const PlasmicEditRoleModal = Object.assign(
  // Top-level PlasmicEditRoleModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    roleName: makeNodeComponent("roleName"),
    permissionSelectStack: makeNodeComponent("permissionSelectStack"),
    permissionSelect: makeNodeComponent("permissionSelect"),
    permissionSelectionStack: makeNodeComponent("permissionSelectionStack"),
    antdOption: makeNodeComponent("antdOption"),
    permissionChipsStack: makeNodeComponent("permissionChipsStack"),
    permissionChip: makeNodeComponent("permissionChip"),
    saveEditRoleBtn: makeNodeComponent("saveEditRoleBtn"),
    // Metadata about props expected for PlasmicEditRoleModal
    internalVariantProps: PlasmicEditRoleModal__VariantProps,
    internalArgProps: PlasmicEditRoleModal__ArgProps
  }
);

export default PlasmicEditRoleModal;
/* prettier-ignore-end */
